import styled from 'styled-components';
import { theme } from 'theme';

const Header = styled.div`
  padding: 10px 20px;
  background-color: ${theme.palette.background.default};
  display: flex;
  flex-direction: row;
  align-items: center;
  position: sticky;
  top: 0;
  left: 0;
  margin: 0 -20px;
  z-index: 10;
`;

export default Header;
